import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AccordionType} from "../../definitions/types";
import {AccordionItemType} from "../../definitions/enums";

export const name = "accordion";

const accordionSlice = createSlice({
    name: name,
    initialState: {
        value: {activeKey: [AccordionItemType.ProductDetails]} as AccordionType
    },
    reducers: {
        setActiveKey: (state, {payload}: PayloadAction<AccordionItemType>) => {
            state.value.activeKey = [payload];
        },
        onClick: (state, {payload}: PayloadAction<AccordionItemType>) => {
            if (state.value.activeKey.includes(payload)) {
                state.value.activeKey = state.value.activeKey.filter(key => key !== payload);
            } else {
                state.value.activeKey.push(payload);
            }
        },
        openIfClosed: (state, {payload}: PayloadAction<AccordionItemType>) => {
            if (state.value.activeKey.includes(payload)) return;
            state.value.activeKey.push(payload);
        },
        closeAll: (state) => {
            state.value.activeKey = [];
        }
    }
});

export const {
    setActiveKey: accordionSetActiveKey,
    onClick: accordionHeaderOnClick,
    openIfClosed: openAccordionItemIfClosed,
    closeAll: accordionCloseAll
} = accordionSlice.actions;
export default accordionSlice.reducer;